import AutoShrinkText from "./AutoShrinkText"

export default AutoShrinkText